/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APIHandler } from 'C4';

import InputField from 'components/LoginForm/Input';
import Countries from './registerCountriesData';
import SearchLocationInput from '../../../components/SearchLocationInput';


export default class RegisterAddress extends Component {
  constructor() {
    super();
    this.state = {
      error: '',
      fullAddress: {},
    };

    this.setAddress = this.setAddress.bind(this);
  }

  async setAddress(address) {
    if (address) {
      this.setState({ fullAddress: address });
    }

    this.props.setAddress(address);
  }

  render() {
    const {
      userInput: { reg_country }, change,
    } = this.props;

    const {
      fullAddress
    } = this.state;

    const { postalCode, city, province, country } = fullAddress;

    const FocusArrow = () => (
      <svg viewBox="0 0 20 20" className="focusArrow">
        <path d="M0 0 L10 10 L0 20" />
      </svg>
    );

    const InputLine = () => (
      <svg className="inputLine" viewBox="0 0 40 2" preserveAspectRatio="none">
        <path d="M0 1 L40 1" />
        <path d="M0 1 L40 1" className="activeFocus" />
      </svg>
    );

    return (
      <React.Fragment>
        <React.Fragment>

          <p>
            <SearchLocationInput setAddress={this.setAddress} />
            <FocusArrow />
            <FontAwesomeIcon icon={['fas', 'map']} />
            <InputLine />
          </p>

          <InputField
            change={change}
            defaultVal={postalCode}
            fieldType="text"
            fieldName="reg_zipcode"
            fieldPlaceholder={i18n.translate('loginScreen.fields.zipCode')}
            icon="map"
          />

          <InputField
            change={change}
            defaultVal={city}
            fieldType="text"
            fieldName="reg_city"
            fieldPlaceholder={i18n.translate('loginScreen.fields.city')}
            icon="map"
          />

          <InputField
            change={change}
            defaultVal={province}
            fieldType="text"
            fieldName="reg_state"
            fieldPlaceholder={`${((this.props.userInput.reg_country === 'US') || (this.props.userInput.reg_country === '')) ?
            i18n.translate('loginScreen.fields.state') :
            i18n.translate('loginScreen.fields.province')}`}
            icon="map"
          />
          
          <p>
            <input
              list="countries"
              name="reg_country"
              placeholder={i18n.translate('loginScreen.fields.country')}
              value={country}
              onChange={change}
              required
            />
            <datalist id="countries">
              {Countries.map((c, index) => {
              const key = index;
              return (
                <option key={key} value={c.name}>{c.name}</option>
              );
            })}
            </datalist>
            <FocusArrow />
            <FontAwesomeIcon icon={['fas', 'map']} />
            <InputLine />
          </p>
        </React.Fragment>
      </React.Fragment>
    );
  }
}

RegisterAddress.propTypes = {
  userInput: PropTypes.shape({
    reg_country: PropTypes.string.isRequired,
  }).isRequired,
  change: PropTypes.func.isRequired,
};
